import React, { useContext } from 'react';
import MenuItem from '@mui/material/MenuItem';
import { ThemeContext } from 'styled-components';
import Divider from "@mui/material/Divider";

// Helper function to convert hex to rgba
const hexToRgba = (hex, alpha) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const ButtonDivider = ({
    fadeStart = 10,
    solidStart = 30,
    solidEnd = 70,
    fadeEnd = 90,
    ...props
}) => {
    const theme = useContext(ThemeContext);

    // Convert secondary to rgba base for opacity control
    const shadowColorSolid = hexToRgba(theme.colors.text, 0.4);

    return (
        <Divider sx={{p:0, background: `linear-gradient(to right, transparent 0%, ${theme.colors.menuText} 0%, ${theme.colors.menuText} 60%, transparent 100%)`}}>
                {/* Shadow gradient positioned beneath the divider, matching the divider's fade pattern */}
            <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                width: '100%',
                height: '2px',
                // background: `linear-gradient(to right, transparent ${fadeStart}%, ${shadowColorSolid} ${solidStart}%, ${shadowColorSolid} ${solidEnd}%, transparent ${fadeEnd}%)`,
                filter: 'blur(1px)',
                pointerEvents: 'none',
            }} />
        </Divider>
    );
};

export default ButtonDivider;
